import styled from 'styled-components';
import { PrsDefaultButton } from '../../../styles-and-themes/styles/prsButtons';

export const RegistrationModalContentContainer = styled.div`
  max-width: 375px;
  background-color: light-yellow;
`;

export const ContinueButton = styled(PrsDefaultButton)`
  width: 100%;
`;
